/*
 * Copyright 2016-present Evernote Corporation. All rights reserved.
 *
 * QA Util
 * Contains automation IDs and templates
 */

export const ViewPane = 'qa-ViewPane';

// Buttons
export const CREATE_SPACE_BUTTON = 'qa-CREATE_SPACE_BUTTON';
export const NOTES_HEADER_SHARE_BUTTON = 'qa-NOTES_HEADER_SHARE_BUTTON';
export const SHARE_BUTTON = 'qa-SHARE_BUTTON';
export const MEMBER_COUNT_BUTTON = 'qa-MEMBER_COUNT_BUTTON';
export const SIDEBAR_UPGRADE_BUTTON = 'qa-SIDEBAR_UPGRADE_BUTTON';
export const WEB_CLIPPER_LINK_BUTTON = 'qa-WEB_CLIPPER_LINK_BUTTON';

// Spaces view
export const SPACE_TITLE = 'qa-SPACE_TITLE';
export const SPACE_CREATE_NOTEBOOK = 'qa-SPACE_CREATE_NOTEBOOK';
export const SPACE_HEADER_ACTIONS = 'qa-SPACE_HEADER_ACTIONS';
export const SPACE_ACTION_LEAVE = 'qa-SPACE_ACTION_LEAVE';
export const SPACE_ACTION_MANAGE = 'qa-SPACE_ACTION_MANAGE';
export const SPACE_ACTION_IMPORT = 'qa-SPACE_ACTION_IMPORT';
export const SPACE_VIEW_LIST = 'qa-SPACE_VIEW_LIST';
export const SPACE_VIEW_BOARD = 'qa-SPACE_VIEW_BOARD';
export const SPACE_VIEW_TOTAL_NOTE_COUNT = 'qa-SPACE_VIEW_TOTAL_NOTE_COUNT';
export const SPACE_DASHBOARD = 'qa-SPACE_DASHBOARD';
export const SPACE_SURVEY_WIDGET = 'qa-SPACE_SURVEY_WIDGET';
export const SPACE_SUMMARY_WIDGET = 'qa-SPACE_SUMMARY_WIDGET';
export const SPACE_RECENT_NOTES_WIDGET = 'qa-SPACE_RECENT_NOTES_WIDGET';
export const SPACE_EMPTY_SPACE = 'qa-SPACE_EMPTY_SPACE';
// Empty state content (SPACY-308)
export const EMPTY_SPACE_IMG = 'qa-EMPTY_SPACE_IMG';
export const EMPTY_SPACE_HEADER = 'qa-EMPTY_SPACE_HEADER';
export const EMPTY_SPACE_CREATE_NOTE_BTN = 'qa-EMPTY_SPACE_CREATE_NOTE_BTN';
export const EMPTY_SPACE_ATTACH_BTN = 'qa-EMPTY_SPACE_ATTACH_BTN';
export const EMPTY_SPACE_CREATE_NOTEBOOK_BTN = 'qa-EMPTY_SPACE_CREATE_NOTEBOOK_BTN';
export const EMPTY_SPACE_CREATE_MOVE_IN_NOTES_BTN =
  'qa-EMPTY_SPACE_CREATE_MOVE_IN_NOTES_BTN';
export const EMPTY_SPACE_EXAMPLES_LINK = 'qa-EMPTY_SPACE_EXAMPLES_LINK';
export const EMPTY_SPACE_EXAMPLES_BTN = 'qa-EMPTY_SPACE_EXAMPLES_BTN';

// Board view (alternate Spaces view)
export const boardViewList = (listIndex: number): string =>
  `qa-BOARD_VIEW_LIST_${listIndex}`;
export const BOARD_VIEW_LIST_TITLE = 'qa-BOARD_VIEW_LIST_TITLE';
export const BOARD_VIEW_LIST_ICON = 'qa-BOARD_VIEW_LIST_ICON';
export const BOARD_VIEW_LIST_NOTE_COUNT = 'qa-BOARD_VIEW_LIST_NOTE_COUNT';
export const BOARD_VIEW_LIST_NOTE = 'qa-BOARD_VIEW_LIST_NOTE';
export const boardViewListNote = (listIndex: number, noteIndex: number): string =>
  `qa-BOARD_VIEW_LIST_NOTE_${listIndex}_${noteIndex}`;
export const BOARD_VIEW_LIST_NOTE_TITLE = 'qa-BOARD_VIEW_LIST_NOTE_TITLE';
export const BOARD_VIEW_LIST_ADD_NOTE_BTN = 'qa-BOARD_VIEW_LIST_ADD_NOTE_BTN';
export const BOARD_VIEW_LIST_SAVE_NOTE_BTN = 'qa-BOARD_VIEW_LIST_SAVE_NOTE_BTN';
export const BOARD_VIEW_LIST_EDIT_NOTE_BTN = 'qa-BOARD_VIEW_LIST_EDIT_NOTE_BTN';
export const BOARD_VIEW_LIST_NOTE_CLOSE_BTN = 'qa-BOARD_VIEW_LIST_NOTE_CLOSE_BTN';
export const BOARD_VIEW_LIST_NOTE_ADD_NOTE_BTN = 'qa-BOARD_VIEW_LIST_NOTE_ADD_NOTE_BTN';
export const BOARD_VIEW_NEW_NOTEBOOK_BTN = 'qa-BOARD_VIEW_NEW_NOTEBOOK_BTN';

// Leave space dialog
export const LEAVE_WORSPACE_CONFIRM_DIALOG = 'qa-LEAVE_WORSPACE_CONFIRM_DIALOG';
export const LEAVE_WORSPACE_CONFIRM_DIALOG_CLOSE = 'qa-LEAVE_WORSPACE_CLOSE';
export const LEAVE_WORSPACE_CONFIRM_DIALOG_SUBMIT = 'qa-LEAVE_WORSPACE_SUBMIT';
export const LEAVE_WORSPACE_CONFIRM_DIALOG_CANCEL = 'qa-LEAVE_WORSPACE_CANCEL';
export const LEAVE_WORSPACE_CONFIRM_DIALOG_HEADER = 'qa-LEAVE_WORSPACE_HEADER';

// Container
export const SPACE_VIEW = 'qa-SPACE_VIEW';
export const SPACE_TABLE = 'qa-SPACE_TABLE';
export const SPACE_TABLE_HEAD = 'qa-SPACE_TABLE_HEAD';
export const SPACE_TABLE_BODY = 'qa-SPACE_TABLE_BODY';
export const SPACE_INVITE_MEMBERS = 'qa-SPACE_INVITE_MEMBERS';
export const SPACE_VIEW_MEMBER_COUNT = 'qa-SPACE_VIEW_MEMBER_COUNT';
// Table Headers
export const SPACE_VIEW_TOTAL_NOTECOUNT = 'qa-SPACE_TOTAL_NOTE_COUNT';
export const SPACE_VIEW_SHARED_BY_HEADER = 'qa-SPACE_VIEW_SHARED_WITH_HEADER';
export const SPACE_VIEW_TITLE_HEADER = 'qa-SPACE_VIEW_TITLE_HEADER';
export const SPACE_VIEW_LAST_EDITED_USER_HEADER = 'qa-SPACE_VIEW_LAST_EDITED_USER_HEADER';
export const SPACE_VIEW_CREATOR_HEADER = 'qa-SPACE_VIEW_CREATOR_HEADER';
export const SPACE_VIEW_DATE_HEADER = 'qa-SPACE_VIEW_DATE_HEADER';
export const SPACE_VIEW_SHARED_COUNT_HEADER = 'qa-SPACE_VIEW_SHARED_COUNT_HEADER';
export const SPACE_VIEW_SPACE_NAME_HEADER = 'qa-SPACE_VIEW_SPACE_NAME_HEADER';
export const SPACE_VIEW_UPDATED_HEADER = 'qa-SPACE_VIEW_UPDATED_HEADER';
export const SPACE_VIEW_DELETED_HEADER = 'qa-SPACE_VIEW_DELETED_HEADER';
export const SPACE_VIEW_ACTIONS_HEADER = 'qa-SPACE_VIEW_ACTIONS_HEADER';
export const SPACE_VIEW_WORKSPACE_HEADER = 'qa-SPACE_VIEW_WORKSPACE_HEADER';
// Stacks
export const NOTEBOOK_STACK_TITLE = 'qa-NOTEBOOK_STACK_TITLE';
export const NAV_NOTEBOOK_STACK_COLLAPSE = 'qa-NAV_NOTEBOOK_STACK_HEADER';
export const SPACE_VIEW_STACK_TITLE = 'qa-SPACE_VIEW_STACK_TITLE';
export const SPACE_VIEW_STACK_NOTEBOOK_COUNT = 'qa-SPACE_VIEW_STACK_NOTEBOOK_COUNT';
// Notebooks
export const SPACE_VIEW_NOTEBOOK_TITLE = 'qa-SPACE_VIEW_NOTEBOOK_TITLE';
export const SPACE_VIEW_NOTEBOOK_NOTE_COUNT = 'qa-SPACE_NOTEBOOK_NOTE_COUNT';
export const SPACE_VIEW_NOTEBOOK_CREATOR = 'qa-SPACE_VIEW_NOTEBOOK_CREATOR';
export const SPACE_VIEW_NOTEBOOK_EDITOR = 'qa-SPACE_VIEW_NOTEBOOK_EDITOR';
export const SPACE_VIEW_NOTEBOOK_UPDATED = 'qa-SPACE_VIEW_NOTEBOOK_UPDATED';
export const SPACE_VIEW_NOTEBOOK_SHARED_COUNT = 'qa-SPACE_VIEW_NOTEBOOK_SHARED_COUNT';
export const SPACE_VIEW_NOTEBOOK_SHARED_BY = 'qa-SPACE_VIEW_NOTEBOOK_SHARED_BY';
export const SPACE_VIEW_NOTEBOOK_SHARED_BY_WITH_AVATAR =
  'qa-SPACE_VIEW_NOTEBOOK_SHARED_BY_WITH_AVATAR';
export const SPACE_VIEW_NOTEBOOK_SHARE_DATE = 'qa-SPACE_VIEW_NOTEBOOK_SHARE_DATE';
export const SPACE_VIEW_NOTEBOOK_WORKSPACE = 'qa-SPACE_VIEW_NOTEBOOK_WORKSPACE';
export const SPACE_VIEW_EXPAND_ICON = 'qa-SPACE_VIEW_EXPAND_ICON';
// Notes
export const SPACE_VIEW_NOTE_TITLE = 'qa-SPACE_VIEW_NOTE_TITLE';
export const SPACE_VIEW_NOTE_CREATOR = 'qa-SPACE_VIEW_NOTE_CREATOR';
export const SPACE_VIEW_NOTE_UPDATED = 'qa-SPACE_VIEW_NOTE_UPDATED';
export const SPACE_VIEW_NOTE_DELETED = 'qa-SPACE_VIEW_NOTE_DELETED';
export const SPACE_VIEW_NOTE_SHARED_COUNT = 'qa-SPACE_VIEW_NOTE_SHARED_COUNT';
export const SPACE_VIEW_NOTE_SHARED_BY = 'qa-SPACE_VIEW_NOTE_SHARED_BY';
export const SPACE_VIEW_NOTE_SHARED_BY_WITH_AVATAR =
  'qa-SPACE_VIEW_NOTE_SHARED_BY_WITH_AVATAR';
export const SPACE_VIEW_NOTE_WORKSPACE = 'qa-SPACE_VIEW_NOTE_WORKSPACE';
export const SPACE_VIEW_NOTE_NOTEBOOK = 'qa-SPACE_VIEW_NOTE_NOTEBOOK';
// Tags
export const tagName = (name: string): string => `qa-TAG_NAME_${name}`;
export const TAG_INPUT = 'qa-TAG_INPUT';
export const tagListRow = (i: number): string => `qa-TAG_LIST_ROW_${i}`;
export const TAG_NAME = 'qa-TAG_NAME_COUNT';
export const SELECTED_TAG_FILTER = 'qa-SELECTED_TAG_FILTER';
export const TAG_FILTER = 'qa-TAG_FILTER';
export const TAG_FILTER_INPUT = 'qa-TAG_FILTER_INPUT';
export const tagsKingdomHeaderTitle = (title: string): string =>
  `qa-TAGS_KINGDOM_HEADER_${title}`;
export const TAG_REMOVE_FROM_ALL_NOTES = 'qa-TAG_REMOVE_ALL_NOTES';
export const TAG_KINGDOM_NO_MATCHES_FOUND = 'qa-TAG_KINGDOM_NO_MATCHES_FOUND';
export const TAG_KINGDOM_TAG_FILTER_INPUT = 'qa-TAG_KINGDOM_TAG_FILTER_INPUT';
// Actions
export const ACTIONS_MODAL = 'qa-ACTIONS_MODAL';
export const ACTION_ADD_TO_STACK = 'qa-ACTION_ADD_TO_STACK';
export const ADD_TO_CREATED_STACK = 'qa-ADD_TO_CREATED_STACK';
export const ACTION_COPY = 'qa-ACTION_COPY';
export const ACTION_COPY_INTERNAL_LINK = 'qa-ACTION_COPY_INTERNAL_LINK';
export const ACTION_DELETE = 'qa-ACTION_DELETE';
export const ACTION_DROPDOWN = 'qa-ACTION_DROPDOWN';
export const ACTION_EXPUNGE = 'qa-ACTION_EXPUNGE';
export const ACTION_LEAVE = 'qa-ACTION_LEAVE';
export const ACTION_MOVE = 'qa-ACTION_MOVE';
export const ACTION_NOTEINFO = 'qa-ACTION_NOTEINFO';
export const ACTION_PRINT = 'qa-ACTION_PRINT';
export const ACTION_REMOVE_FROM_STACK = 'qa-ACTION_REMOVE_FROM_STACK';
export const ACTION_RENAME = 'qa-ACTION_RENAME';
export const ACTION_RESTORE = 'qa-ACTION_RESTORE';
export const ACTION_SAVETEMPLATE = 'qa-ACTION_SAVETEMPLATE';
export const ACTION_SELECTED = 'qa-ACTION_SELECTED';
export const ACTION_SET_AS_DEFAULT = 'qa-ACTION_SET_AS_DEFAULT';
export const ACTION_SHARE = 'qa-ACTION_SHARE';
export const ACTION_SHORTCUT = 'qa-ACTION_SHORTCUT';
export const ACTION_CREATE_MINDMAP_TABLE = 'qa-ACTION_CREATE_MIDNMAP_TABLE';
export const ACTION_SWITCH_EDITOR_MODE = 'qa-ACTION_SWITCH_EDITOR_MODE';
export const ACTION_VIEW_STACK = 'qa-ACTION_VIEW_STACK';
export const NOTE_ACTIONS = 'qa-NOTE_ACTIONS';
export const NOTEBOOK_ACTIONS = 'qa-NOTEBOOK_ACTIONS';
// Drop down to select a view type
export const SPACE_VIEW_DROPDOWN = 'qa-SPACE_VIEW_DROPDOWN';
export const SPACE_VIEW_DROPDOWN_NEW_LABEL = 'qa-SPACE_VIEW_DROPDOWN_NEW_LABEL';

// Invited members icons
export const invitedMember = (name: string, i: number) => `qa-MEMBER_${i}`;

// NAV (SIDEBAR)
export const NAV = 'qa-NAV';
export const CREATE_NOTE = 'qa-CREATE_NOTE';
export const SPACE_DIRECTORY = 'qa-SPACE_DIRECTORY';
export const NAV_ADMIN_INVITE = 'qa-NAV_ADMIN_INVITE';

// All Notes
export const NAV_ALL_NOTES = 'qa-NAV_ALL_NOTES';
export const NAV_ALL_NOTES_AND_NOTEBOOKS = 'qa-NAV_ALL_NOTES_AND_NOTEBOOKS';
export const ALL_NOTES_EMPTY_LINK = 'qa-ALL_NOTES_EMPTY_LINK';

// All Notebooks
export const NAV_ALL_NOTEBOOKS = 'qa-NAV_ALL_NOTEBOOKS';
export const ALL_NOTEBOOKS_CREATE_NOTEBOOK = 'qa-ALL_NOTEBOOKS_CREATE_NOTEBOOK';
export const ALL_NOTEBOOKS_FILTER_INPUT = 'qa-ALL_NOTEBOOKS_FILTER_INPUT';

// Shared with me
export const SHARED_WITH_ME = 'qa-SHARED_WITH_ME';

// Search
export const SEARCH_BOX = 'qa-NAV_SEARCH_BOX';
export const SEARCH_PANEL = 'qa-NAV_SEARCH_PANEL';
export const SEARCH_SUGGESTION = 'qa-SEARCH_SUGGESTION';
export const SUGGESTION_NAME = 'qa-SUGGESTION_NAME';
export const DELETE_SUGGESTION = 'qa-DELETE_SUGGESTION';
export const SEARCH_BTN = 'qa-SEARCH_BTN';
export const CLOSE_SEARCH_BTN = 'qa-CLOSE_SEARCH_BTN';
export const FILTER_ITEM = 'qa-FILTER_ITEM';
export const FILTER_NAME = 'qa-FILTER_NAME';

// Shortcuts Section
export const NAV_SHORTCUTS_HEADER = 'qa-NAV_SHORTCUTS_HEADER';
export const navShortcut = (i: number): string => `qa-NAV_SHORTCUT_${i}`;
export const NAV_SHORTCUTS_COLLAPSE = 'qa-NAV_SHORTCUTS_HEADER';

// Tasks
export const NAV_TASKS = 'qa-NAV_TASKS';
export const TASK_COMPLETED_PLACEHOLDER = 'qa-TASK_COMPLETED_PLACEHOLDER';
export const TASKS_EMPTY_PLACEHOLDER = 'qa-TASKS_EMPTY_PLACEHOLDER';
export const TASKS_TABLE = 'qa-TASKS_TABLE';
export const COMPLETED_TASKS_TABLE = 'qa-COMPLETED_TASKS_TABLE';
export const ALL_TASKS_TABLE = 'qa-ALL_TASKS_TABLE';
export const TASKS_TITLE_HEADER = 'qa-TASKS_TITLE_HEADER';
export const TASKS_LOCATED_HEADER = 'qa-TASKS_LOCATED_HEADER';
export const TASKS_ASSIGNED_HEADER = 'qa-TASKS_ASSIGNED_HEADER';
export const TASK_REMINDERS_HEADER = 'qa-TASK_REMINDERS_HEADER';
export const TASKS_DUE_HEADER = 'qa-TASKS_DUE_HEADER';
export const TASK_ACTIONS_HEADER = 'qa-TASK_ACTIONS_HEADER';
export const TASK_TITLE_CELL = 'qa-TASK_TITLE_CELL';
export const TASK_LOCATED_CELL = 'qa-TASK_LOCATED_CELL';
export const TASK_ASSIGNED_CELL = 'qa-TASK_ASSIGNED_CELL';
export const TASK_DUE_CELL = 'qa-TASK_DUE_CELL';
export const TASK_REMINDERS_CELL = 'qa-TASK_REMINDERS_CELL';
export const ACTION_TASK_DELETE = 'qa-ACTION_TASK_DELETE';
export const ACTION_TASK_EDIT = 'qa-ACTION_TASK_EDIT';
export const TASK_ACTIONS = 'qa-TASK_ACTIONS';
export const TASK_EDITOR_TITLE_TEXTAREA = 'qa-TASK_EDITOR_TITLE_TEXTAREA';
export const TASK_CREATE_TASK_MODAL = 'qa-TASK_CREATE_TASK_MODAL';
export const TASK_CREATE_TASK_MODAL_SUBMIT_BTN = 'qa-TASK_CREATE_TASK_MODAL_SUBMIT_BTN';
export const TASK_CREATE_TASK_MODAL_CANCEL_BTN = 'qa-TASK_CREATE_TASK_MODAL_CANCEL_BTN';
export const TASK_CREATE_TASK_MODAL_X_BTN = 'qa-TASK_CREATE_TASK_MODAL_X_BTN';
export const TASK_EDIT_TASK_MODAL = 'qa-TASK_EDIT_TASK_MODAL';
export const TASK_EDIT_TASK_MODAL_SUBMIT_BTN = 'qa-TASK_EDIT_TASK_MODAL_SUBMIT_BTN';
export const TASK_EDIT_TASK_MODAL_CANCEL_BTN = 'qa-TASK_EDIT_TASK_MODAL_CANCEL_BTN';
export const TASK_EDIT_TASK_MODAL_X_BTN = 'qa-TASK_EDIT_TASK_MODAL_X_BTN';
export const TASK_MODAL_SPACE_BREADCRUMB = 'qa-TASK_MODAL_SPACE_BREADCRUMB';
export const TASK_MODAL_NOTEBOOK_BREADCRUMB = 'qa-TASK_MODAL_NOTEBOOK_BREADCRUMB';
export const TASK_MODAL_NOTE_BREADCRUMB = 'qa-TASK_MODAL_NOTE_BREADCRUMB';
export const MY_TASKS_BTN = 'qa-MY_TASKS_BTN';
export const ALL_TASKS_BTN = 'qa-ALL_TASKS_BTN';
export const ADD_TASK_INPUT = 'qa-ADD_TASK_INPUT';
export const ADD_TASK_ICON = 'qa-ADD_TASK_ICON';
export const ADD_TASKS_BTN = 'qa-ADD_TASKS_BTN';
export const COMPLETED_TASK_ICON = 'qa-COMPLETED_TASK_ICON';
export const TASK_CHECKBOX_ICON = 'qa-TASK_CHECKBOX_ICON';
export const COMPLETED_TASKS_EXPAND_ICON = 'qa-COMPLETED_TASKS_EXPAND_ICON';
export const COMPLETED_TASKS_HEADER = 'qa-COMPLETED_TASKS_HEADER';
export const COMPLETED_TASKS_COUNT = 'qa-COMPLETED_TASKS_COUNT';
export const TASKS_GROUP_BY_NONE = 'qa-TASKS_GROUP_BY_NONE';
export const TASKS_GROUP_BY_DATE = 'qa-TASKS_GROUP_BY_DATE';
export const TASKS_GROUP_BY_DATE_HEADER = 'qa-TASK_GROUP_BY_DATE_HEADER';
export const TASKS_GROUP_BY_DATE_TOGGLE_EXPAND = 'qa-TASKS_GROUP_BY_DATE_TOGGLE_EXPAND';

// Me Space
export const NAV_ME_SPACE = 'qa-NAV_ME_SPACE';

// Notebooks Section
export const NAV_NOTEBOOKS_HEADER = 'qa-NAV_NOTEBOOKS_HEADER';
export const navNotebook = (i: number): string => `qa-NAV_NOTEBOOK_${i}`;
export const NAV_NOTEBOOKS_COLLAPSE = 'qa-NAV_NOTEBOOKS_HEADER';

// Spaces Section
export const NAV_SPACES_HEADER = 'qa-NAV_SPACES_HEADER';
export const navSpace = (i: number): string => `qa-NAV_SPACE_${i}`;
export const NAV_SPACE_BADGE = 'qa-NAV_SPACE_BADGE';

// Trash
export const NAV_TRASH = 'qa-NAV_TRASH';
export const TRASH_VIEW = 'qa-TRASH_VIEW';
export const TRASH_TOTAL_NOTECOUNT = 'qa-SPACE_TOTAL_NOTE_COUNT';
export const TRASH_SHARED_BY_HEADER = 'qa-TRASH_SHARED_WITH_HEADER';
export const TRASH_TITLE_HEADER = 'qa-TRASH_TITLE_HEADER';
export const TRASH_CREATOR_HEADER = 'qa-TRASH_CREATOR_HEADER';
export const TRASH_DELETED_HEADER = 'qa-TRASH_DELETED_HEADER';
export const TRASH_SHARED_COUNT_HEADER = 'qa-TRASH_SHARED_COUNT_HEADER';
export const TRASH_ACTIONS_HEADER = 'qa-SPACE_VIEW_ACTIONS_HEADER';

// User
export const NAV_USER = 'qa-NAV_USER';

// Note Detail
export const NOTE_DETAIL = 'qa-NOTE_DETAIL';
export const NOTE_EDITOR = 'qa-NOTE_EDITOR';
export const NOTE_HEADER = 'qa-NOTE_HEADER';
export const NOTE_EDITOR_TITLE = 'qa-NOTE_EDITOR_TITLE';
export const NOTE_DETAIL_ACTIONS = 'qa-NOTE_DETAIL_ACTIONS';
export const NOTE_PARENT_SPACE_BTN = 'qa-NOTE_PARENT_SPACE_BTN';
export const NOTE_PARENT_NOTEBOOK_BTN = 'qa-NOTE_PARENT_NOTEBOOK_BTN';
export const NOTE_TRASH_BTN = 'qa-NOTE_TRASH_BTN';
export const NOTE_TITLE_BREADCRUMB = 'qa-NOTE_TITLE_BREADCRUMB';
export const NOTE_BACK_ARROW = 'qa-NOTE_BACK_ARROW';
export const NOTE_FULLSCREEN_BTN = 'qa-NOTE_FULLSCREEN_BTN';

// Editor
export const COMMON_EDITOR_IFRAME = 'qa-COMMON_EDITOR_IFRAME';
export const NOTE_EDIT_INFO = 'qa-NOTE_EDIT_INFO';

// Notes T-Pain
export const NOTES_HEADER = 'qa-NOTES_HEADER';
export const NOTES_HEADER_SPACE_ICON = 'qa-NOTES_HEADER_SPACE_ICON';
export const NOTES_HEADER_SPACE_NAME = 'qa-NOTES_HEADER_SPACE_NAME';
export const NOTES_HEADER_NOTEBOOK_NAME = 'qa-NOTES_HEADER_NOTEBOOK_NAME';
export const NOTES_HEADER_SETTINGS = 'qa-NOTES_HEADER_SETTINGS';
export const NOTES_HEADER_NOTE_COUNT = 'qa-NOTES_HEADER_NOTE_COUNT';
export const NOTES_EDITOR_SHARE_COUNT = 'qa-NOTES_EDITOR_SHARE_COUNT';
export const NOTEBOOK_SHARE_COUNT = 'qa-NOTEBOOK_SHARE_COUNT';
export const NOTES_HEADER_SORT_TYPE = 'qa-NOTES_HEADER_SORT_TYPE';
export const NOTES_HEADER_SORT_DIRECTION = 'qa-NOTES_HEADER_SORT_DIRECTION';
export const NOTES_SIDEBAR = 'qa-NOTES_SIDEBAR';
export const NOTES_SIDEBAR_NOTE = 'qa-NOTES_SIDEBAR_NOTE';
export const NOTES_SIDEBAR_NOTE_TITLE = 'TITLE';
export const NOTES_SIDEBAR_NOTE_SNIPPET = 'SNIPPET';
export const NOTES_SIDEBAR_NOTE_UPDATED = 'UPDATED';
export const NOTES_DETAIL_NOTEBOOK_NAME = 'qa-NOTES_DETAIL_NOTEBOOK_NAME';
export const NOTE_FOOTER = 'qa-NOTE_FOOTER';
export const NOTELIST_SUBHEADER_ACTIONS = 'qa-NOTELIST_SUBHEADER_ACTIONS';

// Move Dialog
export const MOVE_ENTITY_DIALOG = 'qa-MOVE_ENTITY_DIALOG';
export const MOVE_ENTITY_CLOSE = 'qa-MOVE_ENTITY_CLOSE';
export const MOVE_TITLE = 'qa-MOVE_TITLE';
export const MOVE_MODAL_CANCEL_BUTTON = 'qa-MOVE_INVITE_CANCEL_BUTTON';
export const MOVE_MODAL_CONTINUE_BUTTON = 'qa-MOVE_INVITE_CONTINUE_BUTTON';
export const MOVE_MODAL_MEMBER_COUNT = 'qa-MOVE_MODAL_MEMBER_COUNT';
export const MOVE_MODAL_MEMBER_ICON = 'qa-MOVE_MODAL_MEMBER_ICON';
export const MOVE_MODAL_REMOVE_NOTEBOOK = 'qa-MOVE_MODAL_REMOVE_NOTEBOOK';
export const MOVE_MODAL_ROW_ICON = 'qa-MOVE_MODAL_ROW_ICON';
export const MOVE_MODAL_ROW_NAME = 'qa-MOVE_MODAL_ROW_NAME';
export const MOVE_MODAL_SELECTED_ICON = 'qa-MOVE_MODAL_SELECTED_ICON';

// Select and Create Dialog
export const SELECT_AND_CREATE_DIALOG = 'qa-SELECT_AND_CREATE_DIALOG';
export const SELECT_AND_CREATE_CLOSE = 'qa-SELECT_AND_CREATE_CLOSE';
export const SELECT_AND_CREATE_MODAL_CONTINUE = 'qa-SELECT_AND_CREATE_MODAL_CONTINUE';
export const SELECT_AND_CREATE_MODAL_CANCEL = 'qa-SELECT_AND_CREATE_MODAL_CANCEL';
export const SELECT_AND_CREATE_MODAL_TREE_VIEW = 'qa-SELECT_AND_CREATE_MODAL_TREE_VIEW';

// TreeView
export const treeViewRow = (keys: number[]): string => {
  const keyString = keys.join('_');
  return `qa-TREE_VIEW_ROW_${keyString}`;
};
export const TREE_VIEW_ROW_ARROW = 'qa-TREE_VIEW_ARROW';

// Move Invite Dialog
export const MOVE_INVITE_HEADER = 'qa-MOVE_INVITE_HEADER';
export const MOVE_INVITE_CLOSE = 'qa-MOVE_INVITE_CLOSE';
export const MOVE_INVITE_DIALOG = 'qa-MOVE_INVITE_DIALOG';
export const MOVE_INVITE_IN_SPACE = 'qa-MOVE_INVITE_IN_SPACE';
export const MOVE_INVITE_WARNING = 'qa-MOVE_INVITE_WARNING';
export const MOVE_INVITE_SELECT_DESELECT_BUTTON = 'qa_MOVE_INVITE_SELECT_DESELECT_BUTTON';
export const MOVE_INVITE_USER_CHECK = 'qa-MOVE_INVITE_USER_CHECK';
export const MOVE_INVITE_CANCEL_BUTTON = 'qa-MOVE_INVITE_CANCEL_BUTTON';
export const MOVE_INVITE_CONTINUE_BUTTON = 'qa-MOVE_INVITE_CONTINUE_BUTTON';
export const moveInviteAvatarId = (name: string, id: number) =>
  `qa-MOVE_INVITE_USER_AVATAR_${id}`;

// User List
export const USER_LIST_EMAIL = 'qa-USER_LIST_EMAIL';
export const USER_LIST_NAME = 'qa-USER_LIST_USER_NAME';
export const userListUserRow = (i: number): string => `qa-USER_LIST_ROW_${i}`;

// Generic dialog
export const DIALOG = 'qa-DIALOG';
export const DIALOG_HEADER = 'qa-DIALOG_HEADER';
export const DIALOG_CLOSE = 'qa-DIALOG_CLOSE';
export const DIALOG_SUBMIT = 'qa-DIALOG_SUBMIT';
export const DIALOG_CANCEL = 'qa-DIALOG_CANCEL';
export const DIALOG_ERROR = 'qa-DIALOG_ERROR';
export const DIALOG_LOADING_SPINNER = 'qa-DIALOG_LOADING_SPINNER';
export const dialogInput = (i: number): string => `qa-DIALOG_INPUT_${i}`;
// Dialog elements related to Space View Type selection
export const DIALOG_BOARD_VIEW_IMG = 'qa-DIALOG_BOARD_VIEW_IMG';
export const DIALOG_LIST_VIEW_IMG = 'qa-DIALOG_LIST_VIEW_IMG';
export const DIALOG_VIEW_TYPE_SUBHEADER = 'qa-DIALOG_VIEW_TYPE_SUBHEADER';
export const DIALOG_LIST_VIEW_RADIO_BTN = 'qa-DIALOG_LIST_VIEW_RADIO_BTN';
export const DIALOG_LIST_VIEW_INFO = 'qa-DIALOG_LIST_VIEW_INFO';
export const DIALOG_LIST_VIEW_LABEL = 'qa-DIALOG_LIST_VIEW_LABEL';
export const DIALOG_BOARD_VIEW_RADIO_BTN = 'qa-DIALOG_BOARD_VIEW_RADIO_BTN';
export const DIALOG_BOARD_VIEW_INFO = 'qa-DIALOG_BOARD_VIEW_INFO';
export const DIALOG_BOARD_VIEW_LABEL = 'qa-DIALOG_BOARD_VIEW_LABEL';

// Email list dialog
export const EMAIL_DIALOG_INNER = 'qa-EMAIL_DIALOG_INNER';
export const EMAIL_DIALOG_TITLE = 'qa-EMAIL_DIALOG_TITLE';
export const EMAIL_DIALOG_EMAILS = 'qa-EMAIL_DIALOG_EMAILS';
export const EMAIL_DIALOG_SUBMIT = 'qa-EMAIL_DIALOG_SUBMIT';
export const EMAIL_DIALOG_CLOSE = 'qa-EMAIL_DIALOG_CLOSE';
export const EMAIL_DIALOG_ERROR = 'qa-EMAIL_DIALOG_ERROR';

// Email verification dialog
export const EMAIL_VERIFICATION_DIALOG = 'qa-EMAIL_VERIFICATION_DIALOG';
export const EMAIL_VERIFICATION_DIALOG_CLOSE = 'qa-EMAIL_VERIFICATION_DIALOG_CLOSE';
export const EMAIL_VERIFICATION_DIALOG_SUBMIT = 'qa-EMAIL_VERIFICATION_DIALOG_SUBMIT';
export const EMAIL_VERIFICATION_DIALOG_CANCEL = 'qa-EMAIL_VERIFICATION_DIALOG_CANCEL';
export const EMAIL_VERIFICATION_DIALOG_CHANGE_EMAIL =
  'qa-EMAIL_VERIFICATION_DIALOG_CHANGE_EMAIL';
export const EMAIL_VERIFICATION_DIALOG_MAIN_COPY =
  'qa-EMAIL_VERIFICATION_DIALOG_MAIN_COPY';

// Phone number bind dialog
export const PHONE_NUMBER_BIND_DIALOG = 'qa-PHONE_NUMBER_BIND_DIALOG';

// Create Notebook
export const CREATE_NOTEBOOK_DIALOG = 'qa-CREATE_NOTEBOOK_DIALOG';
export const CREATE_NOTEBOOK_HEADER = 'qa-CREATE_NOTEBOOK_HEADER';
export const CREATE_NOTEBOOK_NAME = 'qa-CREATE_NOTEBOOK_NAME';
export const CREATE_NOTEBOOK_SUBMIT = 'qa-CREATE_NOTEBOOK_SUBMIT';
export const CREATE_NOTEBOOK_ERROR = 'qa-CREATE_NOTEBOOK_ERROR';
export const CREATE_NOTEBOOK_CLOSE = 'qa-CREATE_NOTEBOOK_CLOSE';

// Share Note
export const SHARE_DIALOG = 'qa-SHARE_DIALOG_DIALOG';
export const SHARE_DIALOG_HEADER = 'qa-SHARE_DIALOG_HEADER';
export const SHARE_DIALOG_CLOSE = 'qa-SHARE_DIALOG_CLOSE';
export const SHARE_DIALOG_SUBMIT = 'qa-SHARE_DIALOG_SUBMIT';
export const SHARE_DIALOG_CANCEL = 'qa-SHARE_DIALOG_CANCEL';
export const SHARE_DIALOG_TEXTAREA = 'qa-SHARE_DIALOG_TEXTAREA';
export const SHARE_DIALOG_DROPDOWN = 'qa-SHARE_DIALOG_DROPDOWN';
export const SHARE_DIALOG_BUTTON_AREA = 'qa-SHARE_DIALOG_BUTTON_AREA';
export const SHARE_DIALOG_DROPDOWN_INVITE = 'qa-SHARE_DIALOG_DROPDOWN_INVITE';
export const SHARE_DIALOG_DROPDOWN_EDIT = 'qa-SHARE_DIALOG_DROPDOWN_EDIT';
export const SHARE_DIALOG_DROPDOWN_VIEW = 'qa-SHARE_DIALOG_DROPDOWN_VIEW';
export const SHARE_DIALOG_RESHARE = 'qa-SHARE_DIALOG_RESHARE';
export const SHARE_DIALOG_PENDING = 'qa-SHARE_DIALOG_PENDING';
export const SHARE_DIALOG_REMOVE_ACCESS = 'qa-SHARE_DIALOG_REMOVE_ACCESS';
export const SHARE_DIALOG_STOP = 'qa-SHARE_DIALOG_STOP';
export const SHARE_DIALOG_LEAVE_WORKSPACE = 'qa-SHARE_DIALOG_LEAVE_WORKSPACE';
export const shareDialogDropdownButton = (id: number): string =>
  `qa-SHARE_DIALOG_USER_LIST_DROPDOWN_TEXT_${id}`;
export const SHARE_DIALOG_SHARED_WITH_ARROW = 'qa-SHARE_DIALOG_SHARED_WITH_ARROW';
export const shareDialogSharedWithName = (id: number): string =>
  `qa-SHARE_DIALOG_SHARED_WITH_NAME_${id}`;
export const SHARE_DIALOG_SHARED_WITH_MORE = 'qa-SHARE_DIALOG_SHARED_WITH_MORE';
export const SHARE_NOTE_PUBLIC_START = 'qa-SHARE_NOTE_PUBLIC_START';
export const SHARE_NOTE_PUBLIC_STOP = 'qa-SHARE_NOTE_PUBLIC_STOP';
export const SHARE_NOTE_PUBLIC_LINK = 'qa-SHARE_NOTE_PUBLIC_LINK';
export const SHARE_NOTE_PUBLIC_LINK_STATUS = 'qa-SHARE_NOTE_PUBLIC_LINK_STATUS';
export const SHARE_NOTE_PUBLIC_COPY_LINK = 'qa-SHARE_NOTE_PUBLIC_COPY_LINK';

// Spaces Directory
export const DIRECTORY_DEFAULT = 'qa-DIRECTORY_DEFAULT';
export const DIRECTORY_VIEW = 'qa-DIRECTORY_READ';
export const DIRECTORY_EDIT = 'qa-DIRECTORY_EDIT';
export const DIRECTORY_FULL = 'qa-DIRECTORY_FULL';

// Account Dropdown
export const ACCOUNT_DROPDOWN_HEADER = 'qa-ACCOUNT_DROPDOWN_HEADER';
export const ACCOUNT_DROPDOWN_MAIN_ACCOUNT = 'qa-ACCOUNT_DROPDOWN_MAIN_ACCOUNT';
export const ACCOUNT_DROPDOWN_SECONDARY_ACCOUNT = 'qa-ACCOUNT_DROPDOWN_SECONDARY_ACCOUNT';
export const ACCOUNT_DROPDOWN_ADMIN = 'qa-ACCOUNT_DROPDOWN_ADMIN';
export const ACCOUNT_DROPDOWN_SETTINGS = 'qa-ACCOUNT_DROPDOWN_SETTINGS';
export const ACCOUNT_DROPDOWN_PERSONAL_SETTINGS = 'qa-ACCOUNT_DROPDOWN_PERSONAL_SETTINGS';
export const ACCOUNT_DROPDOWN_WHATS_NEW = 'qa-ACCOUNT_DROPDOWN_WHATS_NEW';
export const ACCOUNT_DROPDOWN_HELP = 'qa-ACCOUNT_DROPDOWN_HELP';
export const ACCOUNT_DROPDOWN_FOCUS = 'qa-ACCOUNT_DROPDOWN_FOCUS';
export const ACCOUNT_DROPDOWN_LOGOUT = 'qa-ACCOUNT_DROPDOWN_LOGOUT';

// Attachment File Dialog
export const ATTACH_FILE_DIALOG_WRAPPER = 'qa-ATTACH_FILE_DIALOG_WRAPPER';
export const ATTACH_FILE_DIALOG_TITLE = 'qa-ATTACH_FILE_DIALOG_TITLE';
export const ATTACH_FILE_DIALOG_SUBMIT = 'qa-ATTACH_FILE_DIALOG_SUBMIT';
export const CANCEL_FILE_DIALOG_SUBMIT = 'qa-CANCEL_FILE_DIALOG_SUBMIT';
export const ATTACH_FILE_DIALOG_FILE_INPUT = 'qa-ATTACH_FILE_DIALOG_FILE_INPUT';

// Account Limit Dialog
export const ACCOUNT_LIMIT_IFRAME = 'qa-ACCOUNT_LIMIT_IFRAME';

// Delete Confirmation Dialog
export const DELETE_CONFIRM_DIALOG = 'qa-DELETE_CONFIRM_DIALOG';
export const DELETE_CONFIRM_DIALOG_CLOSE = 'qa-DELETE_CONFIRM_DIALOG_CLOSE';
export const DELETE_CONFIRM_DIALOG_HEADER = 'qa-DELETE_CONFIRM_DIALOG_HEADER';
export const DELETE_CONFIRM_DIALOG_SUBMIT = 'qa-DELETE_CONFIRM_DIALOG_SUBMIT';
export const DELETE_CONFIRM_DIALOG_MESSAGE = 'qa-DELETE_CONFIRM_DIALOG_MESSAGE';
export const DELETE_CONFIRM_DIALOG_CANCEL = 'qa-DELETE_CONFIRM_DIALOG_CANCEL';

// Reload Note Dialog
export const RELOAD_DIALOG_SUBMIT = 'qa-RELOAD_DIALOG_SUBMIT';
export const RELOAD_DIALOG_X_BTN = 'qa-RELOAD_DIALOG_X_BTN';

//Tag Limit exceeded dialog
export const SHOW_TAG_LIMIT_DIALOG_SUBTITLE = 'qa-SHOW_TAG_LIMIT_DIALOG_SUBTITLE';
export const SHOW_TAG_LIMIT_DIALOG_TITLE = 'qa-SHOW_TAG_LIMIT_DIALOG_TITLE';
export const SHOW_TAG_LIMIT_DIALOG = 'qa-SHOW_TAG_LIMIT_DIALOG';

// Search Results View
export const SEARCH_RESULTS_TITLE_HEADER = 'qa-SEARCH_RESULTS_TITLE_HEADER';
export const SEARCH_RESULTS_LOCATION_HEADER = 'qa-SEARCH_RESULTS_LOCATION_HEADER';
export const SEARCH_RESULTS_UPDATED_HEADER = 'qa-SEARCH_RESULTS_UPDATED_HEADER';
export const SEARCH_RESULTS_TOTAL_NOTECOUNT = 'qa-SEARCH_RESULTS_TOTAL_NOTECOUNT';
export const SEARCH_RESULTS_TABLE = 'qa-SEARCH_RESULTS_TABLE';
export const searchResultsRowNote = (i: number): string =>
  `qa-SEARCH_RESULTS_TABLE_ROW_NOTE_${i}`;
export const SEARCH_RESULTS_NOTE_TITLE = 'qa-SEARCH_RESULTS_NOTE_TITLE';
export const SEARCH_RESULTS_LOCATION = 'qa-SEARCH_RESULTS_LOCATION';
export const SEARCH_RESULTS_NOTE_UPDATED = 'qa-SEARCH_RESULTS_NOTE_UPDATED';
export const SEARCH_RESULTS_QUERY_TITLE = 'qa-SEARCH_RESULTS_QUERY_TITLE';
export const SEARCH_VIEW_TOTAL_ITEMS_COUNT = 'qa-SEARCH_VIEW_TOTAL_ITEMS_COUNT';

// Formatting Bar
export const FONTTYPE_DROPDOWN = 'qa-FONTTYPE_DROPDOWN';
export const FONTTYPE_LABEL = 'qa-FONTTYPE_LABEL';
export const FONTSIZE_DROPDOWN = 'qa-FONTTYPE_DROPDOWN';
export const FONTSIZE_LABEL = 'qa-FONTSIZE_LABEL';
export const FONTCOLOR_DROPDOWN = 'qa-FONTCOLOR_DROPDOWN';
export const BACKGROUNDCOLOR_DROPDOWN = 'qa-BACKGROUNDCOLOR_DROPDOWN';
export const FONTCOLOR_LABEL = 'qa-FONTCOLOR_LABEL';
export const BACKGROUNDCOLOR_LABEL = 'qa-BACKGROUNDCOLOR_LABEL';
export const FORMATTING_BAR_ATTACH_ICON = 'qa-FORMATTING_BAR_ATTACH_ICON';
export const BOLD_TEXT_BTN = 'qa-BOLD_TEXT_BTN';
export const ITALIC_TEXT_BTN = 'qa-ITALIC_TEXT_BTN';
export const UNDERLINE_TEXT_BTN = 'qa-UNDERLINE_TEXT_BTN';
export const STRIKETHROUGH_TEXT_BTN = 'qa-STRIKETHROUGH_TEXT_BTN';
export const HIGHLIGHT_TEXT_BTN = 'qa-HIGHLIGHT_TEXT_BTN';
export const ATTACHMENT_BTN = 'qa-ATTACHMENT_BTN';
export const TABLE_BTN = 'qa-TABLE_BTN';
export const DIVIDER_BTN = 'qa-DIVIDER_BTN';
export const CODEBLOCK_BTN = 'qa-CODEBLOCK_BTN';
export const BLOCKQUOTE_BTN = 'qa-BLOCKQUOTE_BTN';
export const ADD_TODO_BTN = 'qa-ADD_TODO_BTN';
export const ADD_TASK_BTN = 'qa-ADD_TASK_BTN';
export const TODO_OR_TASK_DROPDOWN = 'qa-TODO_OR_TASK_DROPDOWN';
export const UNORDEREDLIST_BTN = 'qa-UNORDEREDLIST_BTN';
export const ORDEREDLIST_BTN = 'qa-ORDEREDLIST_BTN';
export const ADD_TABLE_BTN = 'qa-ADD_TABLE_BTN';
export const ADD_HORIZONTALRULE_BTN = 'qa-ADD_HORIZONTALRULE_BTN';
export const ALIGNMENT_DROPDOWN = 'qa-ALIGNMENT_DROPDOWN';
export const ALIGNMENT_LABEL = 'qa-ALIGNMENT_LABEL';
export const INDENT_BTN = 'qa-INDENT_BTN';
export const OUTDENT_BTN = 'qa-OUTDENT_BTN';
export const SUBSCRIPT_BTN = 'qa-SUBSCRIPT_BTN';
export const SUPERSCRIPT_BTN = 'qa-SUPERSCRIPT_BTN';
export const REMOVEFORMAT_BTN = 'qa-REMOVEFORMAT_BTN';
// Formatting Bar - font type dropdown items
export const FONT_DEFAULT = 'qa-FONT_DEFAULT';
export const FONT_GEORGIA = 'qa-FONT_GEORGIA';
export const FONT_HELVETICA = 'qa-FONT_HELVETICA';
export const FONT_COURIER_NEW = 'qa-FONT_COURIER_NEW';
export const FONT_TIMES_NEW_ROMAN = 'qa-FONT_TIMES_NEW_ROMAN';
export const FONT_TREBUCHET = 'qa-FONT_TREBUCHET';
export const VERDANA = 'qa-VERDANA';
// Formatting Bar - colors
export const BLACK_COLOR_LABEL = 'qa-BLACK_COLOR_LABEL';
export const DARKGRAY_COLOR_LABEL = 'qa-DARKGRAY_COLOR_LABEL';
export const LIGHTGRAY_COLOR_LABEL = 'qa-LIGHTGRAY_COLOR_LABEL';
export const PURPLE_COLOR_LABEL = 'qa-PURPLE_COLOR_LABEL';
export const MAGENTA_COLOR_LABEL = 'qa-MAGENTA_COLOR_LABEL';
export const RED_COLOR_LABEL = 'qa-RED_COLOR_LABEL';
export const ORANGE_COLOR_LABEL = 'qa-ORANGE_COLOR_LABEL';
export const MUSTARD_COLOR_LABEL = 'qa-MUSTARD_COLOR_LABEL';
export const GREEN_COLOR_LABEL = 'qa-GREEN_COLOR_LABEL';
export const LIGHTBLUE_COLOR_LABEL = 'qa-LIGHTBLUE_COLOR_LABEL';
export const BLUE_COLOR_LABEL = 'qa-BLUE_COLOR_LABEL';
export const DARKBLUE_COLOR_LABEL = 'qa-DARKBLUE_COLOR_LABEL';

// Semantic Formatting Bar
export const HEADING_DROPDOWN = 'qa-HEADING_DROPDOWN';
export const HEADING_LABEL = 'qa-HEADING_LABEL';
export const TODOLIST_BTN = 'qa-TODOLIST_BTN';
export const INSERT_DROPDOWN = 'qa-INSERT_DROPDOWN';
export const INSERT_LABEL = 'qa-INSERT_LABEL';

// Semantic Formatting Bar - heading dropdown items
export const HEADING_TITLE = 'qa-HEADING_TITLE';
export const HEADING_LARGE = 'qa-HEADING_LARGE';
export const HEADING_SMALL = 'qa-HEADING_SMALL';
export const HEADING_NONE = 'qa-HEADING_NONE';

// Semantic Formatting Bar - fontsize dropdown items

export const FONTSIZE_12 = 'qa-FONTSIZE_12';
export const FONTSIZE_14 = 'qa-FONTSIZE_14';
export const FONTSIZE_16 = 'qa-FONTSIZE_16';
export const FONTSIZE_18 = 'qa-FONTSIZE_18';
export const FONTSIZE_20 = 'qa-FONTSIZE_20';
export const FONTSIZE_24 = 'qa-FONTSIZE_24';
export const FONTSIZE_28 = 'qa-FONTSIZE_28';
export const FONTSIZE_36 = 'qa-FONTSIZE_36';

// Board View - colors
export const WHITE_COLOR_LABEL = 'qa-WHITE_COLOR_LABEL';
export const GALLERY_COLOR_LABEL = 'qa-GALLERY_COLOR_LABEL';
export const ALTO_COLOR_LABEL = 'qa-ALTO_COLOR_LABEL';
export const MOONRAKER_COLOR_LABEL = 'qa-MOONRAKER_COLOR_LABEL';
export const MOONRAKER2_COLOR_LABEL = 'qa-MOONRAKER2_COLOR_LABEL';
export const PIGPINK_COLOR_LABEL = 'qa-PIGPINK_COLOR_LABEL';
export const NEGRONI_COLOR_LABEL = 'qa-NEGRONI_COLOR_LABEL';
export const CREAMBRULEE_COLOR_LABEL = 'qa-CREAMBRULEE_COLOR_LABEL';
export const TARA_COLOR_LABEL = 'qa-TARA_COLOR_LABEL';
export const ICEBERG_COLOR_LABEL = 'qa-ICEBERG_COLOR_LABEL';
export const TROPICALBLUE_COLOR_LABEL = 'qa-TROPICALBLUE_COLOR_LABEL';
export const PERIWINKLEBLUE_COLOR_LABEL = 'qa-PERIWINKLEBLUE_COLOR_LABEL';
export const MINESHAFT_COLOR_LABEL = 'qa-MINESHAFT_COLOR_LABEL';
export const DOVEGRAY_COLOR_LABEL = 'qa-DOVEGRAY_COLOR_LABEL';
export const DUSTYGRAY_COLOR_LABEL = 'qa-DUSTYGRAY_COLOR_LABEL';
export const MEDIUMPURPLE_COLOR_LABEL = 'qa-MEDIUMPURPLE_COLOR_LABEL';
export const LAVENDER_COLOR_LABEL = 'qa-LAVENDER_COLOR_LABEL';
export const CARNATION_COLOR_LABEL = 'qa-CARNATION_COLOR_LABEL';
export const CRUSTA_COLOR_LABEL = 'qa-CRUSTA_COLOR_LABEL';
export const AMBER_COLOR_LABEL = 'qa-AMBER_COLOR_LABEL';
export const FERN_COLOR_LABEL = 'qa-FERN_COLOR_LABEL';
export const FOUNTAINBLUE_COLOR_LABEL = 'qa-FOUNTAINBLUE_COLOR_LABEL';
export const PICTONBLUE_COLOR_LABEL = 'qa-PICTONBLUE_COLOR_LABEL';
export const SANMARINO_COLOR_LABEL = 'qa-SANMARINO_COLOR_LABEL';

// Formatting Bar - alignment dropdown items
export const ALIGNMENT_TOLEFT = 'qa-ALIGNMENT_TOLEFT';
export const ALIGNMENT_TOCENTER = 'qa-ALIGNMENT_TOCENTER';
export const ALIGNMENT_TORIGHT = 'qa-ALIGNMENT_TORIGHT';
export const ALIGNMENT_JUSTIFY = 'qa-ALIGNMENT_JUSTIFY';

// Message Toast
export const TOAST_CLOSE_BUTTON = 'qa-TOAST_CLOSE_BUTTON';
export const TOAST_ICON = 'qa-TOAST_ICON';

// Platform Alert Confirm
export const PLATFORM_CONFIRM_ALERT = 'qa-PLATFORM_CONFIRM_ALERT';
export const PLATFORM_CONFIRM_ALERT_CLOSE = 'qa-PLATFORM_CONFIRM_ALERT_CLOSE';
export const PLATFORM_CONFIRM_ALERT_SUBMIT = 'qa-PLATFORM_CONFIRM_ALERT_SUBMIT';
export const PLATFORM_CONFIRM_ALERT_CANCEL = 'qa-PLATFORM_CONFIRM_ALERT_CANCEL';
export const PLATFORM_CONFIRM_ALERT_MESSAGE = 'qa-PLATFORM_CONFIRM_ALERT_MESSAGE';

// Platform Form Dialog
export const PLATFORM_FORM_DIALOG = 'qa-PLATFORM_FORM_DIALOG';
export const PLATFORM_FORM_DIALOG_CLOSE = 'qa-PLATFORM_FORM_DIALOG_CLOSE';
export const PLATFORM_FORM_DIALOG_SUBMIT = 'qa-PLATFORM_FORM_DIALOG_SUBMIT';
export const PLATFORM_FORM_DIALOG_CANCEL = 'qa-PLATFORM_FORM_DIALOG_CANCEL';
export const PLATFORM_FORM_DIALOG_ELEMENTS = 'qa-PLATFORM_FORM_DIALOG_ELEMENTS';

// Note Links
export const NOTE_LINK_HOVER_DIV = 'qa-NOTE_LINK_HOVER_DIV';
export const NOTE_LINK_HOVER_URL = 'qa-NOTE_LINK_HOVER_URL';
export const NOTE_LINK_HOVER_EDIT = 'qa-NOTE_LINK_HOVER_EDIT';
export const NOTE_LINK_HOVER_REMOVE = 'qa-NOTE_LINK_HOVER_REMOVE';
export const NOTE_LINK_POPUP_DIV = 'qa-NOTE_LINK_POPUP_DIV';
export const NOTE_LINK_POPUP_TITLE = 'qa-NOTE_LINK_POPUP_TITLE';
export const NOTE_LINK_POPUP_URL = 'qa-NOTE_LINK_POPUP_URL';
export const NOTE_LINK_POPUP_CANCEL = 'qa-NOTE_LINK_POPUP_CANCEL';
export const NOTE_LINK_POPUP_ADD = 'qa-NOTE_LINK_POPUP_ADD';
export const NOTE_LINK_POPUP_BUTTON = 'qa-NOTE_LINK_POPUP_BUTTON';

// Import Dialog
export const IMPORT_DIALOG = 'qa-IMPORT_DIALOG';
export const IMPORT_DIALOG_CLOSE = 'qa-IMPORT_DIALOG_CLOSE';
export const IMPORT_DIALOG_SUBMIT = 'qa-IMPORT_DIALOG_SUBMIT';
export const IMPORT_DIALOG_CANCEL = 'qa-IMPORT_DIALOG_CANCEL';
export const IMPORT_DIALOG_TREE_VIEW = 'qa-IMPORT_DIALOG_TREE_VIEW';
export const IMPORT_DIALOG_HEADER = 'qa-IMPORT_DIALOG_HEADER';
export const IMPORT_DIALOG_SUBHEADER = 'qa-IMPORT_DIALOG_SUBHEADER';
export const IMPORT_DIALOG_ITEM_TITLE = 'qa-IMPORT_DIALOG_ITEM_TITLE';
export const IMPORT_DIALOG_ITEM_CHECKBOX = 'qa-IMPORT_DIALOG_ITEM_CHECKBOX';
export const IMPORT_DIALOG_CHECKED_COUNTER = 'qa-IMPORT_DIALOG_CHECKED_COUNTER';

// Generic Lightbox
export const GENERIC_LIGHTBOX_DIALOG = 'qa-GENERIC_LIGHTBOX_DIALOG';
export const GENERIC_LIGHTBOX_SUBMIT = 'qa-GENERIC_LIGHTBOX_DIALOG_SUBMIT';
export const GENERIC_LIGHTBOX_IMAGE = 'qa-GENERIC_LIGHTBOX_IMAGE';
export const GENERIC_LIGHTBOX_HEADER = 'qa-GENERIC_LIGHTBOX_HEADER';
export const GENERIC_LIGHTBOX_BODY = 'qa-GENERIC_LIGHTBOX_BODY';
export const GENERIC_LIGHTBOX_CLOSE = 'qa-GENERIC_LIGHTBOX_CLOSE';

// FLE Tooltip
export const FLE_TOOLTIP_CLOSE_BUTTON = 'qa-FLE_TOOLTIP_CLOSE_BUTTON';
export const FLE_TOOLTIP_BUTTON = 'qa-FLE_TOOLTIP_BUTTON';
export const FLE_TOOLTIP_HEADER = 'qa-FLE_TOOLTIP_HEADER';
export const FLE_TOOLTIP_BODY = 'qa-FLE_TOOLTIP_BODY';
export const FLE_TOOLTIP_PROGRESS = 'qa-FLE_TOOLTIP_PROGRESS';

// Tags Kingdom
export const TAGS_KINGDOM = 'qa-TAGS_KINGDOM';
export const TAGS_KINGDOM_TITLE = 'qa-TAGS_KINGDOM_TITLE';
export const TAGS_KINGDOM_EMPTY_STATE = 'qa-TAGS_KINGDOM_EMPTY_STATE';
export const NAV_TAGS = 'qa-NAV_TAGS';
export const TAG_ITEM = 'qa-TAG_ITEM';
export const TAG_ITEM_COUNT = 'qa-TAG_ITEM_COUNT';
export const TAGS_KINGDOM_CREATE_TAG = 'qa-TAGS_KINGDOM_CREATE_TAG';

// TagFooterList
export const ADD_TAG_BTN = 'qa-ADD_TAG_BTN';

// Tag Menu
export const FILTER_BY_TAG = 'qa-FILTER_BY_TAG';
export const TAG_MENU_REMOVE_TAG = 'qa-TAG_MENU_REMOVE_TAG';
export const TAG_MENU_DELETE_FROM_ALL_NOTES = 'qa-TAG_MENU_DELETE_FROM_ALL_NOTES';

// Note info
export const NOTE_INFO_URL = 'qa-NOTE_INFO_URL';
export const NOTE_INFO_AUTHOR = 'qa-NOTE_INFO_AUTHOR';
export const NOTE_INFO_VERSION_HISTORY = 'qa-NOTE_INFO_VERSION_HISTORY';
export const NOTE_INFO_TITLE_LABEL = 'qa-NOTE_INFO_TITLE_LABEL';
export const NOTE_INFO_TITLE_VALUE = 'qa-NOTE_INFO_TITLE_VALUE';
export const NOTE_INFO_CREATED_LABEL = 'qa-NOTE_INFO_CREATED_LABEL';
export const NOTE_INFO_CREATED_VALUE = 'qa-NOTE_INFO_TITLE_VALUE';
export const NOTE_INFO_UPDATED_LABEL = 'qa-NOTE_INFO_UPDATED_LABEL';
export const NOTE_INFO_UPDATED_VALUE = 'qa-NOTE_INFO_UPDATED_VALUE';
export const NOTE_INFO_SIZE_LABEL = 'qa-NOTE_INFO_SIZE_LABEL';
export const NOTE_INFO_SIZE_VALUE = 'qa-NOTE_INFO_SIZE_VALUE';
export const NOTE_INFO_HISTORY_LABEL = 'qa-NOTE_INFO_HISTORY_LABEL';

// Unsupported Platform
export const UNSUPPORTED_PLATFORM = 'qa-UNSUPPORTED_PLATFORM';
export const UNSUPPORTED_PLATFORM_ADMIN_CONSOLE = 'qa-UNSUPPORTED_PLATFORM_ADMIN_CONSOLE';
export const UNSUPPORTED_PLATFORM_DOWNLOAD_EN = 'qa-UNSUPPORTED_PLATFORM_DOWNLOAD_EN';
export const UNSUPPORTED_PLATFORM_DOWNLOAD_CHROME =
  'qa-UNSUPPORTED_PLATFORM_DOWNLOAD_CHROME';

// Auto-update
export const NAV_AUTOUPDATE = 'qa-NAV_AUTOUPDATE';

// Feedback
export const NAV_FEEDBACK = 'qa-NAV_FEEDBACK';
export const FEEDBACK_TITLE = 'qa-FEEDBACK_TITLE';
export const SUBMIT_FEEDBACK_DIALOG = 'qa-SUBMIT_FEEDBACK_DIALOG';
export const FEEDBACK_SUBMIT = 'qa-FEEDBACK_SUBMIT';
export const FEEDBACK_CANCEL = 'qa-FEEDBACK_CANCEL';
export const FEEDBACK_CLOSE = 'qa-FEEDBACK_CLOSE';
export const FEEDBACK_TEXTFIELD = 'qa-FEEDBACK_TEXTFIELD';
export const FEEDBACK_ENTRYPOINT_TASKS = 'qa-FEEDBACK_ENTRYPOINT_TASKS';

// Experiments QA Tool
export const NAV_EXPERIMENTS = 'qa-NAV_EXPERIMENTS';
export const EXPERIMENTS_VIEW = 'qa-EXPERIMENTS_VIEW';
export const EXPERIMENTS_VIEW_INNER = 'qa-EXPERIMENTS_VIEW_INNER';

// Sort Dropdown
export const SORTING_DROPDOWN_ICON = 'qa-SORTING_DROPDOWN_ICON';

// Tier Selection Display
export const TIER_SELECTION_DISPLAY_IFRAME = 'qa-TIER_SELECTION_DISPLAY_IFRAME';

// Note Duplicate Message
export const NOTE_DUPLICATE_MESSAGE_DIALOG = 'qa-NOTE_DUPLICATE_MESSAGE_DIALOG';
export const NOTE_DUPLICATE_MESSAGE_DIALOG_CLOSE =
  'qa-NOTE_DUPLICATE_MESSAGE_DIALOG_CLOSE';
export const NOTE_DUPLICATE_MESSAGE_DIALOG_CONTINUE =
  'qa-NOTE_DUPLICATE_MESSAGE_DIALOG_CONTINUE';
export const NOTE_DUPLICATE_MESSAGE_DIALOG_BODY = 'qa-NOTE_DUPLICATE_MESSAGE_DIALOG_BODY';

// Client Login
export const CLIENT_LOGIN = 'qa-CLIENT_LOGIN';
export const CLIENT_LOGIN_USERNAME = 'qa-CLIENT_LOGIN_USERNAME';
export const CLIENT_LOGIN_PASSWORD = 'qa-CLIENT_LOGIN_PASSWORD';
export const CLIENT_LOGIN_LEGAL = 'qa-CLIENT_LOGIN_LEGAL';
export const CLIENT_LOGIN_FORGOT_PASSWORD = 'qa-CLIENT_LOGIN_FORGOT_PASSWORD';
export const TWO_FACTOR_AUTHENTICATION = 'qa-TWO_FACTOR_AUTHENTICATION';
export const TWO_FACTOR_AUTHENTICATION_SUBMIT = 'qa-TWO_FACTOR_AUTHENTICATION_SUBMIT';
export const TWO_FACTOR_AUTHENTICATION_CANCEL = 'qa-TWO_FACTOR_AUTHENTICATION_CANCEL';
export const TWO_FACTOR_AUTHENTICATION_TOKEN_INPUT =
  'qa-TWO_FACTOR_AUTHENTICATION_TOKEN_INPUT';
export const DIFF_ACCOUNT_LOGIN = 'qa-DIFF_ACCOUNT_LOGIN';
export const USE_PREV_VERSION = 'qa-USE_PREV_VERSION';
export const USE_WEB_VERSION = 'qa-USE_WEB_VERSION';

// Note Lost Access Dialog
export const LOST_ACCESS_DIALOG = 'qa-LOST_ACCESS_DIALOG';
export const LOST_ACCESS_DIALOG_SUBMIT = 'qa-LOST_ACCESS_DIALOG_SUBMIT';
export const LOST_ACCESS_DIALOG_CLOSE = 'qa-LOST_ACCESS_DIALOG_CLOSE';

// Comm engine
export const COMM_ENGINE_IFRAME = 'qa-COMM_ENGINE_IFRAME';
export const COMM_ENGINE_MESSAGE_IFRAME = 'qa-COMM_ENGINE_MESSAGE_IFRAME';

// HVA cards
export const HVA_DESKTOP_ACTIVITY_LINK = 'qa-HVA_DESKTOP_ACTIVITY_LINK';
export const HVA_COVER_CARD_CTA = 'qa-HVA_COVER_CARD_CTA';
export const HVA_WEB_CLIPPER_LINK = 'qa-HVA_WEB_CLIPPER_LINK';
export const HVA_ATTACHMENT_ACTIVITY_LINK = 'qa-HVA_ATTACHMENT_ACTIVITY_CARD';

// Business SSO
export const BUSINESS_SSO_MODAL = 'qa-BUSINESS_SSO_MODAL';

// short business welcome modal
export const SHORT_BIZ_WELCOME_LINK = 'qa-SHORT_BIZ_WELCOME_LINK';

// QUOTA_USE_UP
export const QUOTA_USE_UP_DIALOG_SUBMIT = 'qa-QUOTA_USE_UP_DIALOG_SUBMIT';
export const QUOTA_USE_UP_DIALOG_X_BTN = 'qa-QUOTA_USE_UP_DIALOG_X_BTN';

// shareNote QUOTA_USE_UP
export const SHARE_NOTE_QUOTA_USE_UP_DIALOG_SUBMIT =
  'qa-SHARE_NOTE_QUOTA_USE_UP_DIALOG_SUBMIT';
export const SHARE_NOTE_QUOTA_USE_UP_DIALOG_X_BTN =
  'qa-SHARE_NOTE_QUOTA_USE_UP_DIALOG_X_BTN';

// NotSupport SuperNote
export const NOT_SUPPORT_SUPERNOTE_MODAL = 'qa-NOT_SUPPORT_SUPERNOTE_MODAL';

// Mindmap Paywall
export const MINDMAP_PAYWALL_MODAL = 'qa-MINDMAP_PAYWALL_MODAL';

// 笔记资源错误
export const NOTE_RESOURCE_ERROR = 'qa-NOTE_RESOURCE_ERROR';
